module.exports = __webpack_public_path__ + "static/media/29DUNON8.c8a00b56.jpg";